module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0127.jpg?v=10aa8ea0";